export class BillReaderUtility {
	public utilityName: string;
	public showNameKey: boolean;
	public showReferenceNum: boolean;
	public showMeterNum: boolean;

	constructor(billReaderUtility?: Partial<BillReaderUtility>) {
		Object.assign(this, billReaderUtility);
	}
}
